import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'

// -----------------------------------------------------------------------------
// API Calls

function fetchBudgetSubscribers (metricDate) {
  return utils.makeApiCall({
    url: `/api/insights/budget/subscribers/${metricDate}`,
    actionRequest: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS,
    actionReceive: ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS,
    actionFailure: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_FAILURE,
    authenticated: true,
    actionProps: {
      metricDate: metricDate
    }
  })
}

function fetchBudgetSubscribersQuarters () {
  return utils.makeApiCall({
    url: '/api/insights/budget/subscribers/quarters',
    actionRequest: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS,
    actionReceive: ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_QUARTERS,
    actionFailure: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_QUARTERS_FAILURE,
    authenticated: true
  })
}

function fetchBudgetSubscribersExport () {
  return utils.makeApiCall({
    url: '/api/insights/budget/subscribers/export',
    actionRequest: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT,
    actionReceive: ActionTypes.RECEIVE_BUDGET_SUBSCRIBERS_EXPORT,
    actionFailure: ActionTypes.REQUEST_BUDGET_SUBSCRIBERS_EXPORT_FAILURE,
    authenticated: true,
    actionProps: {
      filename: 'BudgetSubscribers.xlsx'
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchBudgetSubscribersIfNeeded (metricDate) {
  return (dispatch, getState) => {
    const state = (getState().budgetSubscribers.byMetricDate[metricDate] || {}).budgetSubscribers
    if (utils.shouldFetch(state)) {
    return dispatch(fetchBudgetSubscribers(metricDate))
    }
    return Promise.resolve()
  }
}

export function fetchBudgetSubscribersQuartersIfNeeded () {
  return (dispatch) => {
    return dispatch(fetchBudgetSubscribersQuarters())
  }
}

export function fetchBudgetSubscribersExportIfNeeded () {
  return (dispatch) => {
    return dispatch(fetchBudgetSubscribersExport())
  }
}

export function setSelectedMetricDateIfNeeded (metricDate) {
  return {
    type: ActionTypes.BUDGET_SUBSCRIBERS_SELECTED_QUARTER,
    metricDate
  }
}